import { useRef } from 'react';

import ResizeCell from './ResizeCell';
import ResizeContext from './ResizeContext';
import { ChartsContainer } from './components';
import sortNodes from './sortNodes';

const ResizeRow = ({ children, onResize, minWidth = 400 }) => {
  const containerRef = useRef(null);
  const cellsRef = useRef([]);

  const handleAddCell = (element) => {
    cellsRef.current = [...cellsRef.current, element];
  };

  const handleRemoveCell = (element) => {
    cellsRef.current = cellsRef.current.filter((cell) => cell !== element);
  };

  const handleMouseDown = (event, currentElement) => {
    event.preventDefault();

    const sortedNodes = sortNodes(cellsRef.current);

    const cellIndex = sortedNodes.findIndex(
      (element) => element === currentElement
    );
    const leftElement = sortedNodes[cellIndex];
    const rightElement = sortedNodes[cellIndex + 1];

    const minWidthPercent = 100 * (minWidth / containerRef.current.offsetWidth);
    const initX = event.clientX;
    const initLeftElementPercent = Number(
      leftElement.style.flexBasis.replace('%', '')
    );
    const initRightElementPercent = Number(
      rightElement.style.flexBasis.replace('%', '')
    );

    const finish = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', finish);

      let cellWidths = cellsRef.current.map((element) =>
        Number(element.style.flexBasis.replace('%', ''))
      );

      onResize(cellWidths);
    };

    const handleMouseMove = (event) => {
      if (
        event.x < 0 ||
        event.y < 0 ||
        event.x > document.body.offsetWidth ||
        event.y > document.body.offsetHeight
      ) {
        finish();
      }

      const movementX = event.clientX - initX;
      const deltaPercents =
        (100 * movementX) / containerRef.current.offsetWidth;

      const leftElementPercent = initLeftElementPercent + deltaPercents;
      const rightElementPercent = initRightElementPercent - deltaPercents;
      if (
        (leftElementPercent <= minWidthPercent && movementX < 0) ||
        (rightElementPercent <= minWidthPercent && movementX > 0)
      ) {
        return;
      }

      leftElement.style.flexBasis = `${leftElementPercent.toFixed(2)}%`;
      rightElement.style.flexBasis = `${rightElementPercent.toFixed(2)}%`;
      // normalizeRowWidth();
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', finish);
  };

  return (
    <ResizeContext.Provider
      value={{
        addCell: handleAddCell,
        removeCell: handleRemoveCell,
        onMouseDown: handleMouseDown,
      }}
    >
      <ChartsContainer wrap={'nowrap'} grow={1} ref={containerRef}>
        {children}
      </ChartsContainer>
    </ResizeContext.Provider>
  );
};

ResizeRow.Cell = ResizeCell;

export default ResizeRow;
